/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AppDeprecationsCountGet200Response } from '../model';
// @ts-ignore
import { Faq } from '../model';
// @ts-ignore
import { NewFaq } from '../model';
/**
 * FaqApiFaqsCountGet - axios parameter creator
 * 
 * @summary 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FaqApiFaqsCountGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/faqs/count`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FaqApiFaqsGet - axios parameter creator
 * 
 * @summary 
 * @param {number} [limit] Maximum number of results possible
 * @param {string} [sort] Sort according to a specific field.
 * @param {number} [start] Skip a specific number of entries (especially useful for pagination)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FaqApiFaqsGetAxiosParamCreator (limit?: number, sort?: string, start?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/faqs`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (limit !== undefined) {
        localVarQueryParameter['_limit'] = limit;
    }

    if (sort !== undefined) {
        localVarQueryParameter['_sort'] = sort;
    }

    if (start !== undefined) {
        localVarQueryParameter['_start'] = start;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FaqApiFaqsIdDelete - axios parameter creator
 * Delete a record
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FaqApiFaqsIdDeleteAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('faqsIdDelete', 'id', id)
    const localVarPath = `/faqs/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FaqApiFaqsIdGet - axios parameter creator
 * 
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FaqApiFaqsIdGetAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('faqsIdGet', 'id', id)
    const localVarPath = `/faqs/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FaqApiFaqsIdPut - axios parameter creator
 * Update a record
 * @summary 
 * @param {string} id 
 * @param {NewFaq} newFaq 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FaqApiFaqsIdPutAxiosParamCreator (id: string, newFaq: NewFaq, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('faqsIdPut', 'id', id)
    // verify required parameter 'newFaq' is not null or undefined
    assertParamExists('faqsIdPut', 'newFaq', newFaq)
    const localVarPath = `/faqs/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newFaq, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * FaqApiFaqsPost - axios parameter creator
 * Create a new record
 * @summary 
 * @param {NewFaq} newFaq 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function FaqApiFaqsPostAxiosParamCreator (newFaq: NewFaq, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'newFaq' is not null or undefined
    assertParamExists('faqsPost', 'newFaq', newFaq)
    const localVarPath = `/faqs`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newFaq, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for faqsGet operation in FaqApi.
 * @export
 * @interface FaqApiFaqsGetRequest
 */
export interface FaqApiFaqsGetRequest {
    /**
     * Maximum number of results possible
     * @type {number}
     * @memberof FaqApiFaqsGet
     */
    readonly limit?: number

    /**
     * Sort according to a specific field.
     * @type {string}
     * @memberof FaqApiFaqsGet
     */
    readonly sort?: string

    /**
     * Skip a specific number of entries (especially useful for pagination)
     * @type {number}
     * @memberof FaqApiFaqsGet
     */
    readonly start?: number
}

/**
 * Request parameters for faqsIdDelete operation in FaqApi.
 * @export
 * @interface FaqApiFaqsIdDeleteRequest
 */
export interface FaqApiFaqsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof FaqApiFaqsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for faqsIdGet operation in FaqApi.
 * @export
 * @interface FaqApiFaqsIdGetRequest
 */
export interface FaqApiFaqsIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FaqApiFaqsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for faqsIdPut operation in FaqApi.
 * @export
 * @interface FaqApiFaqsIdPutRequest
 */
export interface FaqApiFaqsIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof FaqApiFaqsIdPut
     */
    readonly id: string

    /**
     * 
     * @type {NewFaq}
     * @memberof FaqApiFaqsIdPut
     */
    readonly newFaq: NewFaq
}

/**
 * Request parameters for faqsPost operation in FaqApi.
 * @export
 * @interface FaqApiFaqsPostRequest
 */
export interface FaqApiFaqsPostRequest {
    /**
     * 
     * @type {NewFaq}
     * @memberof FaqApiFaqsPost
     */
    readonly newFaq: NewFaq
}

/**
* 
* @summary 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FaqApiFaqsCountGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FaqApiFaqsCountGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<AppDeprecationsCountGet200Response> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {FaqApiFaqsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FaqApiFaqsGet(requestParameters: FaqApiFaqsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FaqApiFaqsGetAxiosParamCreator(requestParameters.limit, requestParameters.sort, requestParameters.start, options, configuration);
    const request: () => AxiosPromise<Array<Faq>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Delete a record
* @summary 
* @param {FaqApiFaqsIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FaqApiFaqsIdDelete(requestParameters: FaqApiFaqsIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FaqApiFaqsIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {FaqApiFaqsIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FaqApiFaqsIdGet(requestParameters: FaqApiFaqsIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FaqApiFaqsIdGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<Faq> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Update a record
* @summary 
* @param {FaqApiFaqsIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FaqApiFaqsIdPut(requestParameters: FaqApiFaqsIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FaqApiFaqsIdPutAxiosParamCreator(requestParameters.id, requestParameters.newFaq, options, configuration);
    const request: () => AxiosPromise<Faq> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Create a new record
* @summary 
* @param {FaqApiFaqsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function FaqApiFaqsPost(requestParameters: FaqApiFaqsPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await FaqApiFaqsPostAxiosParamCreator(requestParameters.newFaq, options, configuration);
    const request: () => AxiosPromise<Faq> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
